import { useMemo } from "react";
import { Redirect, useLocation } from "react-router";
import { useContract } from "../ContractContext";
import { IContractParams } from "../ContractParams";
import { ContractType } from "../model/ContractViewModel";
import { ContractPath } from "../routing/ContractPath";
import { getUrl } from "../routing/ContractUrls";
import {
  useReturnLocation,
  useMembershipUpgradePageLocationInner,
} from "./MembershipUpgradePage";
import { Location, LocationDescriptorObject } from "history";

export function useContractLoginCallbackPageLocation(
  params: IContractParams
): LocationDescriptorObject {
  const location = useLocation();
  return useMemo(() => {
    return getContractLoginCallbackPageLocation(location, params);
  }, [params, location]);
}

export function getContractLoginCallbackPageLocation(
  location: Location<unknown>,
  params: IContractParams
) {
  const returnTo = location.pathname;
  const url = getUrl(ContractPath.loginCallback, params);
  const search = new URLSearchParams(url.search);
  search.set("returnTo", returnTo);
  const searchString = search.toString();

  return {
    ...url,
    search: searchString ? `?${searchString}` : "",
  };
}

export default function ContractLoginCallbackPage() {
  const returnLocation = useReturnLocation();
  const contract = useContract();
  const membershipUpgradeLocation = useMembershipUpgradePageLocationInner(
    returnLocation.pathname!
  );

  if (
    contract.contractType?.current === ContractType.Member ||
    contract.contractType?.current === ContractType.Premium
  ) {
    return <Redirect to={returnLocation} />;
  }

  return <Redirect to={membershipUpgradeLocation} />;
}
